"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { stripLocalePrefix } from "@/lib/locale-routing"

type MatchKind = "home" | "buy" | "my-esim" | "account"

type HeaderNavLinkProps = {
  href: string
  label: string
  /** Match identifier — keeps server→client props serializable. */
  matchKind: MatchKind
}

function isActiveFor(currentRoute: string, kind: MatchKind): boolean {
  switch (kind) {
    case "home":
      return currentRoute === "/"
    case "buy":
      return currentRoute === "/buy"
    case "my-esim":
      return (
        currentRoute === "/account/esim" ||
        currentRoute.startsWith("/account/esim/")
      )
    case "account":
      return (
        currentRoute === "/account" ||
        (currentRoute.startsWith("/account/") &&
          !currentRoute.startsWith("/account/esim"))
      )
    default:
      return false
  }
}

export function HeaderNavLink({ href, label, matchKind }: HeaderNavLinkProps) {
  const pathname = usePathname() || "/"
  const currentRoute = stripLocalePrefix(pathname) || "/"
  const active = isActiveFor(currentRoute, matchKind)

  return (
    <Link
      href={href}
      className={active ? "active" : undefined}
      aria-current={active ? "page" : undefined}
    >
      {label}
    </Link>
  )
}
